import DOMPurify from "dompurify";

interface RichContentProps {
  content: string;
  className?: string;
}

const looksLikeHtml = (value: string) => /<\/?[a-z][\s\S]*>/i.test(value);

/**
 * Renders blog/article content.
 * - HTML content (from the WYSIWYG editor) is sanitized and interpreted.
 * - Legacy plain-text content is converted into paragraphs.
 */
export const RichContent = ({ content, className }: RichContentProps) => {
  if (!content) return null;

  if (looksLikeHtml(content)) {
    const clean = DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    );
  }

  return (
    <div className={className}>
      {content.split("\n").map((paragraph, index) =>
        paragraph.trim() ? (
          <p key={index} className="mb-4">
            {paragraph}
          </p>
        ) : null
      )}
    </div>
  );
};

export default RichContent;
